import * as cheerio from 'cheerio';
import { OGArticleProps, OGProps, OGType } from '~/utils/enums';


export function initExpandAndCollapse() {
    const collapseExpandElements = document.querySelectorAll(".gibs-collapse-expand-initiate");
  
    if (collapseExpandElements.length > 0) {
        collapseExpandElements.forEach((element: Element, index: number) => {

            let parentElement = element.parentElement;
            let clone = element.cloneNode(true) as HTMLElement;
            let childElement = parentElement?.querySelector('.gibs-collapse-expand-initiate');
            if (typeof(childElement) !== 'undefined' && childElement != null) {
                childElement.replaceWith(clone);
            }

            // Get targetElement by data-target-id
            const targetId = clone.getAttribute("data-target-id");
            const targetElement = document.getElementById(targetId!);

            if (typeof(targetElement) !== 'undefined' && targetElement != null)  {
                targetElement.classList.add("hide");
                let context = {
                    clickingElement: clone,
                    expandCollapseElement: targetElement
                }
                
                let myClickFunc = contentExpandAndCollapse.bind(context);
                // element.removeEventListener("click", myClickFunc, false);

                clone.addEventListener("click", myClickFunc, false);

               
                // element.addEventListener("click", () => {
                //     contentExpandAndCollapse(element as HTMLElement, targetElement);
                // });
            }
    
        });
    }
}
export function contentExpandAndCollapse(event: Event) {
    let clickElement: HTMLElement = this.clickingElement as HTMLElement;

    const DISPLAY_STATE_HIDE = "hide";
    const DISPLAY_STATE_SHOW = "show";

    if(typeof(clickElement) !== 'undefined' && clickElement != null){
        let expandCollapseElement = clickElement;

        const showableElementId = expandCollapseElement.getAttribute("data-target-id");
        const showableElement = document.getElementById(showableElementId!);

        if(typeof(showableElement) !== 'undefined' && showableElement != null){
            const headerElement = expandCollapseElement.querySelector(".gibs-collapse-expand-header");

            if(typeof(headerElement) !== 'undefined' && headerElement != null){
                const showableElementState = headerElement.getAttribute("data-target-state");
                const collapseIconElement = headerElement.querySelector(".gibs-collapse-expand-header-icon-collapse");
                const expandIconElement = headerElement.querySelector(".gibs-collapse-expand-header-icon-expand");

                // if the state is hide, do the opposite interaction
                if (showableElementState === DISPLAY_STATE_HIDE) {
                    expandCollapseElement.classList.add("expand");

                    showableElement.classList.add("show");
                    showableElement.classList.remove("hide");

                    expandIconElement?.classList.add("show");
                    expandIconElement?.classList.remove("hide");

                    collapseIconElement?.classList.add("hide");
                    collapseIconElement?.classList.remove("show");

                    headerElement.setAttribute("data-target-state",  DISPLAY_STATE_SHOW);
                } 
                else {
                    expandCollapseElement.classList.remove("expand");

                    showableElement.classList.remove("show");
                    showableElement.classList.add("hide");

                    expandIconElement?.classList.remove("show");
                    expandIconElement?.classList.add("hide");

                    collapseIconElement?.classList.add("show");
                    collapseIconElement?.classList.remove("hide");

                    headerElement.setAttribute("data-target-state",  DISPLAY_STATE_HIDE);
                }
            }
        }
       
    }

}

export function contentShowAndHide(buttonElement: HTMLElement, targetElement: HTMLElement) {
    // point to the target element, and the button toggles hide and show on the target element, and toggles button's icon and text
    let contentElement = targetElement;
    // toggle the see less and see more text and icon
    if (contentElement!.classList.contains("see-less")) {
        contentElement?.classList.add("see-more");
        contentElement?.classList.remove("see-less");
        buttonElement?.classList.add("see-less");
        buttonElement?.classList.remove("see-more");
        buttonElement!.childNodes[0].nodeValue = "See Less";
    } else {
        contentElement?.classList.add("see-less");
        contentElement?.classList.remove("see-more");
        buttonElement?.classList.add("see-more");
        buttonElement?.classList.remove("see-less");
        buttonElement!.childNodes[0].nodeValue = "See More";
    }
}

export function updateRelativeUrls(htmlContent: string): string {
    const config = useRuntimeConfig();
    const blobStorageBasePath = `${config.public.imgUri}/${config.public.contentName}`;   
    
    const $ = cheerio.load(htmlContent);

    $('img[src^="/media/"]').attr('src', (index, src) => {
        return `${blobStorageBasePath}${src}`;
    });

    $('a[href^="/media/"]').attr('href', (index, href) => {
        return `${blobStorageBasePath}${href}`;
    });

    $('a:not([target])').each(function () {
        const href = $(this).prop('href') as string | undefined; // Type assertion
        if (href && !href.startsWith('#') && !href.startsWith('/') && !href.startsWith('../')) {
            $(this).attr('target', '_blank');
        }
    });

    const updatedContent = $.html();
    return updatedContent;
}

export function updateRelativeUrl(url: string): string {
    const config = useRuntimeConfig();
    const blobStorageBasePath = `${config.public.imgUri}/${config.public.contentName}`;
    const terms: string[] = ['media', 'faculty'];

    for (const term of terms) {
        if (new RegExp(`^(/)?${term}`).test(url)) {
            return `${blobStorageBasePath}/${url.replace(/^\/?/, '')}`;
        }
    }
    return url || '/grey_pixel.png'; // Ensure the function does not return undefined
}

export const extractImageUrls = (content: string): string[] => {
    const $ = cheerio.load(content);
    const imageElements = $('img');
    const imageUrls: string[] = [];
    imageElements.each((_, element) => {
        const imageUrl = $(element).attr('src');
        if (imageUrl) {
            imageUrls.push(imageUrl);
        }
    });
    return imageUrls;
};

export function interpretJsonUri(input: string):string {
    let output = '';
    if (typeof(input) !== 'undefined') {
        output = decodeURI(input.replaceAll(' ','-').replaceAll('/','-').replaceAll(':', '_').toLowerCase());
    }
    return output;
}

export function interpretUriToDisplayText(input: string):string {
    let output = '';
    if (typeof(input) !== 'undefined') {
        output = decodeURI(input.replaceAll('-',' ').replaceAll('_', ' ').replaceAll('  ', ' '));
    }
    return output;
}

export function checkAppHost():Boolean {
    let isPreview = false;
    
    if (process.client) {
        const rePreview = /preview/ig;
        isPreview = (rePreview.test(window.location.hostname)) ? true : false;
    }
  
    return isPreview;
}

interface HeadData {
    title: string;
    keywords: string;
    description: string;
    ogTitle: string;
    ogDescription: string;
    ogUrl: string;
    ogImage?: string;
    ogType: string;
    hid: string;
    articleAuthor?: string;
    articlePublishedTime?: string;
    brochureUrl?: string;
}

function checkBrochure(brochureUrl: string) {
    if(process.client){ 
        const referrer = document.referrer;
        const socialMediaDomains = [
            'facebook.com',
            'linkedin.com',
            'twitter.com',
            'instagram.com',
            'pinterest.com'
        ];
        const isFromSocialMedia = socialMediaDomains.some((domain) => referrer.includes(domain));

        // If the user came from a social media domain and the required HTML structure is present
        if (isFromSocialMedia && brochureUrl) {
            //window.location.href = brochureUrl;  
            try {
                navigateTo(brochureUrl);
            }
            catch { } // TODO : Need to add logger to log the error
        }
    }
}   

export function updateHead({ title, keywords, description, ogTitle, ogDescription, ogImage, ogType, hid, articleAuthor, articlePublishedTime, brochureUrl }: HeadData) {
    const metaTags = [];
    let pageTitle = '';

    // NOTE : Set Default values if no values are set in umbraco
    if ((title === null || title === ''))
    {
        title = "GIBS";
    }
    if ((description === null || description === ''))
    {
        description = title;
    }
    if ((keywords === null || keywords === ''))
    {
        keywords = `${title},${description}`;
    }
    
    if ((ogTitle === null || ogTitle === ''))
    {
        ogTitle = title;
    } 
    if ((ogDescription === null || ogDescription === ''))
    {
        ogDescription = description;
    } 
    if ((keywords === null || keywords === ''))
    {
        keywords = ogTitle;
    } 
    // NOTE : Set Default values if no values are set in umbraco

    if(ogTitle) {
        pageTitle = ogTitle;
    }
    else {
        if (title) {
            pageTitle = title;
        }
    } 
    if (description) {
        metaTags.push({ name: 'description', content: description });
    } else {
        removeProperty(metaTags, 'description');
    }
    if (keywords) {
        metaTags.push({ name: 'keywords', content: keywords });
    } else {
        removeProperty(metaTags, 'keywords');
    }
    if (ogTitle) {
        metaTags.push({ property: OGProps.ogTitle, content: ogTitle });
    } else {
        removeProperty(metaTags, OGProps.ogTitle);
    }
    if (ogDescription) {
        metaTags.push({ property: OGProps.ogDescription, content: ogDescription });
    } else {
        removeProperty(metaTags, OGProps.ogDescription);
    }
    if (ogImage) {
        metaTags.push({ property: OGProps.ogImage, content: ogImage });
    } else {
        removeProperty(metaTags, OGProps.ogImage);
    }
    if (ogType) {
        metaTags.push({ property: OGProps.ogType, content: ogType });
    } else {
        removeProperty(metaTags, OGProps.ogType);
    }
    if (articleAuthor) {
        metaTags.push({ property: OGArticleProps.articleAuthor, content: articleAuthor });
    } else {
        removeProperty(metaTags, OGArticleProps.articleAuthor);
    }
    if (articlePublishedTime) {
        metaTags.push({ property: OGArticleProps.articlePublishedTime, content: articlePublishedTime });
    } else {
        removeProperty(metaTags, OGArticleProps.articlePublishedTime);
    } 
 
    if (pageTitle) {
        useHead({
            title: pageTitle,
            meta: metaTags
        }); 
    }
    else {
        useHead({ 
            title: "GIBS",
            meta: metaTags
        }); 
    }

    useSeoMeta({
        title: pageTitle,
        ogTitle: pageTitle,
        description: ogDescription,
        ogDescription: ogDescription,
        ogImage: ogImage
    });

    useServerSeoMeta({
        title: pageTitle,
        ogTitle: pageTitle,
        description: ogDescription,
        ogDescription: ogDescription,
        ogImage: ogImage
    });

    if (brochureUrl) {
        checkBrochure(brochureUrl);
    }
}

function removeProperty(metaTags, property: string) {
    for (let i = 0; i < metaTags.length; i++) {
        if (metaTags[i].property === property) {
            metaTags.splice(i, 1);
            break;
        }
    }
}

export function populateHead(additionalUrls: string[]) {

        additionalUrls.forEach(url => {
            if (process.client !== null && process.client !== undefined && process.client === true) 
            {
                useHead({
                    link: [
                        {
                            rel: 'preload',
                            as: 'image',
                            href: url
                        }
                    ]
                });
            }
        });
}

// interface LinkData {
//     rel: string;
//     as?: string;
//     href: string;
// }

// export function populateHead(additionalUrls: string[], image?: string) {
//     const links: any[] = [];  

//     additionalUrls.forEach(url => {
//         const linkData: LinkData = {
//             rel: 'preload',
//             href: url
//         };

//         if (image && !linkData.as) {
//             linkData.as = 'image';
//         }

//         links.push({ ...linkData });  
//     });
 
//     useHead({ link: links });
// }

export function isButtonDisplayTextApplyNow(courseClassificationId: number): Boolean {
    let resultText = true;
    if (typeof(courseClassificationId) !== 'undefined' && courseClassificationId != null) {
        switch(courseClassificationId) {
            case CourseType.Academic:
            case CourseType.ExecutiveCourses:
            case CourseType.ShortCourses:
            case CourseType.CustomCourses:
            case CourseType.Coaching:
            case CourseType.EntrepreneurshipCourses:
            case CourseType.InHouse:
                resultText = true;
            break;
            case CourseType.Masterclasses:
            case CourseType.Event:
            case CourseType.Forum:
            case CourseType.Conference:
                resultText = false;
            break;
            default:
                resultText = true;
            break;
        }
    }
    return resultText;
}